module.exports = __webpack_public_path__ + "img/watch+phone_mockup.f891271b.png";